var map = {
	"./amex.svg": "JXDf",
	"./diners.svg": "dNi4",
	"./discover.svg": "cG6L",
	"./jcb.svg": "EopG",
	"./mastercard.svg": "mYEf",
	"./union.svg": "fx+/",
	"./visa.svg": "79/P"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W67C";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards ^\.\/.*\.svg$
// module id = W67C
// module chunks = 1